import { Component, Input, OnInit, forwardRef, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Observable, Subject, ReplaySubject } from 'rxjs/';
import { RxComponent } from 'app/core/components/common/rx.component';
import { CatalogService } from 'app/agora/components/product-data/catalogs/catalog.service';
import { ProductsService } from 'app/agora/components/product-data/products/products.service';
import {BrandService} from '../../../brands/brand.service';
import {ProductGroupService} from '../../../product-groups/product-group.service';

@Component({
    selector: 'itpx-product-edit-base',
    templateUrl: './product-edit-base.component.html',
    styleUrls: ['./product-edit-base.component.css']
})
export class ProductEditBaseComponent  extends RxComponent implements OnInit {

    private domainDict: Observable<{key: string, value: string}[]> = this.service.getDomainDict().map(_ => _.data);
    private domainMapper: any;
    private categoryFamilyDict: Observable<{key: string, value: string}[]> = this.service.getCategoryFamilyDict().map(_ => _.data);
    private categoryFamilyMapper: any;
    private brands: any;
    private typeDict: Observable<{key: string, value: string}[]> = this.service.getTypeDict().map(_ => _.data);
    private levelDict: Observable<{key: string, value: string}[]> = this.service.getLevelDict().map(_ => _.data);
    private groupDict: Observable<{key: string, value: string}[]> = this.service.getGroupDict().map(_ => _.data);
    private segmentDict: Observable<{key: string, value: string}[]> = this.service.getProductSegmentDict().map(_ => _.data);
    private disableBrandSelect: boolean;
    private defaultBrandId: string;
    private showHostedField: boolean;

    @Input() form: FormGroup;
    @Input() createMode: boolean;

    constructor(
        private fb: FormBuilder,
        private catalogService: CatalogService,
        private service: ProductsService,
        private brandService: BrandService,
        private productGroupService: ProductGroupService
    ) {
        super();
    }

    ngOnInit() {
        this.categoryFamilyDict.subscribe(_ => this.categoryFamilyMapper = this.getMapper(_))
        this.domainDict.subscribe(_ => this.domainMapper = this.getMapper(_));
        this.brandService.getBrandList()
            .subscribe(
                body => {
                    this.brands = this.brandService.formatBrandsToDict(body['data']);
                }
            );

        this.form.controls['group.id'].valueChanges
            .flatMap(change => this.productGroupService.getProductGroupDetails(change))
            .subscribe(
                body => {
                    let productGroupDetails = body['data'];

                    if (productGroupDetails && productGroupDetails.brand) {
                        this.disableBrandSelect = true;
                        this.defaultBrandId = productGroupDetails.brand.id;
                        this.form.patchValue({
                            brand: productGroupDetails.brand.id
                        })
                    } else {
                        this.disableBrandSelect = false;
                        this.form.patchValue({
                            brand: null
                        })
                    }
                }
            );
    }

    getMapper(array: Array<any>) {
        let result = {};
        array.forEach(_ => {
            result[_.key] = _.value
        });

        return result;
    }

    formatConfigDisplayValue(key: string) {
        return this ? this[key] : key;
    }

    private onChangeBrand(brandId: any) {
        this.form.patchValue({
            brand: brandId
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/products/edit/base/product-edit-base.component.ts